import { LogStreamWidget } from '@/widgets/log-stream';

export function Logs() {
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="font-display text-4xl tracking-wide text-ugin-text">Activity</h1>
        <p className="text-sm text-ugin-text-muted">
          Skill invocations, scrapes, Arena ingestion — what Ugin has been doing.
        </p>
      </header>
      <LogStreamWidget limit={200} />
    </div>
  );
}
